import moment from "moment-timezone";
export const getTestPoolData = (statDateTime, duration1, duration2, busd) => {
    const fmtDate = "YYYY-MM-DD[T]HH:mm:ss[Z]";
    const startTime = statDateTime ? moment(new Date(statDateTime * 1000)) : moment(); // statDateTime * 1000
    //  .utc();
    const d1 = duration1 ?? 60;
    const d2 = duration2 ?? 60;

    const whitelistStart = moment(startTime).add(d1, "seconds");
    const whitelistEnd = moment(whitelistStart).add(d2, "seconds");

    const whitelistResultDate = moment(whitelistEnd).add(d1, "seconds");

    const purchaseStart = moment(whitelistResultDate).add(d1, "seconds");
    const purchaseEnd = moment(purchaseStart).add(d2, "seconds");

    const claimTokenStart = moment(purchaseEnd).add(d1, "seconds");

    const hasWhitelistResult = new Date().getTime() >= whitelistResultDate;
    return {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 100,
        maxWinnerSwapToken: hasWhitelistResult ? 60 : 0,
        maxAllocationAltCoin: 666666,
        acceptedCurrency: busd ? "BUSD" : "BNB",
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-10T08:00:00.000Z",
        //
        whitelistPeriodStartAt: whitelistStart.utc().format(fmtDate),
        whitelistPeriodEndAt: whitelistEnd.utc().format(fmtDate),
        whitelistWinnerAnnouncementAt: whitelistResultDate.utc().format(fmtDate),
        swapTokenPeriodStartAt: purchaseStart.utc().format(fmtDate),
        swapTokenPeriodEndAt: purchaseEnd.utc().format(fmtDate),
        claimTokenPeriodStartAt: claimTokenStart,

        whitelistFormLink:
            process.env.WHITELIST_FORM_URL || "https://forms.gle/xp1oaccu2fbcsrzS7",
        whitelistResultLink: hasWhitelistResult ? process.env.WHITELIST_RESULT_URL : "",
        // TODO: Contract address
        // contract: {
        //     seed: "0xf767c5FB23577FCca9Df80fAF3F2034011cfD8Ac",
        //     vesting: "0x7a88d2e2eda131856052abd22b1da2f9eca44e82",
        //     mnd: "0x509753abfb77f90c57cf8e937f8246cfb09e83dd",
        //     acceptedToken: "0x8301f2213c0eed49a7e28ae4c3e91722919b8b47",
        // },
        pool: { __typename: "Pool", title: "Seed round 1" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: 0.05,
        vestingTimes: 12,
        pricePerToken: 0.015,
        availableAmountToken: 40000000,
        contributeAmountToken: busd ? 10000 : 0.0375,
        updatedAt: "2022-02-28T06:23:39.353Z",
    };
};
/**
 * POOL data UT test
 */
export const data = {
    contractInit: {
        seedPackage: "375000000000000000",
        hardcap: "22500000000000000000",
        rate: "26666",
    },
    fully: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-10T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-03-08T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-03-15T11:00:00.000Z",
        swapTokenPeriodStartAt: "2022-03-20T03:00:00.000Z",
        swapTokenPeriodEndAt: "2022-03-23T10:30:00.000Z",
        claimTokenPeriodStartAt: "2022-04-01T10:00:00.000Z",
        whitelistFormLink: "https://forms.gle/xp1oaccu2fbcsrzS7",
        whitelistResultLink:
            "https://docs.google.com/spreadsheets/d/14Ul63-BfWVHIYdsH_JfdSA7xG-NoQvG85hIKYyYl1k8",
        pool: { __typename: "Pool", title: "Community Pool" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: null,
        vestingTimes: null,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    upcoming: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-10T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-03-12T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-03-15T11:00:00.000Z",
        swapTokenPeriodStartAt: "2022-03-20T03:00:00.000Z",
        swapTokenPeriodEndAt: "2022-03-23T10:30:00.000Z",
        claimTokenPeriodStartAt: "2022-04-01T10:00:00.000Z",
        pool: { __typename: "Pool", title: "Community Pool" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: null,
        vestingTimes: null,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    // Before whitelist
    whitelist_0: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: undefined,
        competitionPeriodEndAt: undefined,
        whitelistPeriodStartAt: "2022-03-11T08:19:00.000Z",
        whitelistPeriodEndAt: "2022-03-15T11:00:00.000Z",
        swapTokenPeriodStartAt: undefined,
        swapTokenPeriodEndAt: undefined,
        claimTokenPeriodStartAt: undefined,
        pool: { __typename: "Pool", title: "Seed round 1" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: undefined,
        vestingTimes: undefined,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    // whitelist in process
    whitelist_1: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-10T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-03-08T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-03-15T11:00:00.000Z",
        swapTokenPeriodStartAt: undefined,
        swapTokenPeriodEndAt: undefined,
        claimTokenPeriodStartAt: undefined,
        whitelistWinnerAnnouncementAt: undefined,
        whitelistFormLink: "https://forms.gle/xp1oaccu2fbcsrzS7",
        whitelistResultLink: "",
        pool: { __typename: "Pool", title: "Seed round 1" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: undefined,
        vestingTimes: undefined,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    // After: count down or TBA whitelist
    whitelist_2: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-10T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-03-08T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-03-10T09:07:05.000Z",
        swapTokenPeriodStartAt: "2022-03-20T03:00:00.000Z",
        swapTokenPeriodEndAt: "2022-03-23T10:30:00.000Z",
        acceptedCurrency: "BNB",
        whitelistWinnerAnnouncementAt: "2022-03-10T09:07:05.000Z",
        // TBA
        // whitelistWinnerAnnouncementAt: "",
        whitelistFormLink: "https://forms.gle/xp1oaccu2fbcsrzS7",
        whitelistResultLink:
            "https://docs.google.com/spreadsheets/d/14Ul63-BfWVHIYdsH_JfdSA7xG-NoQvG85hIKYyYl1k8",
        // Contract address
        contract: {
            seed: "0xf767c5FB23577FCca9Df80fAF3F2034011cfD8Ac",
            vesting: "0x7a88d2e2eda131856052abd22b1da2f9eca44e82",
            mnd: "0x509753abfb77f90c57cf8e937f8246cfb09e83dd",
            acceptedToken: "0x8301f2213c0eed49a7e28ae4c3e91722919b8b47",
        },
        claimTokenPeriodStartAt: undefined,
        pool: { __typename: "Pool", title: "Seed round 1" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: undefined,
        vestingTimes: undefined,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    // After
    whitelist_3: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-10T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-03-08T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-03-10T09:07:05.000Z",
        swapTokenPeriodStartAt: "2022-03-20T03:00:00.000Z",
        swapTokenPeriodEndAt: "2022-03-23T10:30:00.000Z",
        acceptedCurrency: "BNB",
        // whitelistWinnerAnnouncementAt: "2022-03-10T09:07:05.000Z",
        // TBA
        whitelistWinnerAnnouncementAt: "",
        whitelistFormLink: "https://forms.gle/xp1oaccu2fbcsrzS7",
        whitelistResultLink:
            "https://docs.google.com/spreadsheets/d/14Ul63-BfWVHIYdsH_JfdSA7xG-NoQvG85hIKYyYl1k8",
        // Contract address
        contract: {
            seed: "0x9FFa71518ECf07f1a940b8405540cD702b88e2fb",
            vesting: "0x7a88d2e2eda131856052abd22b1da2f9eca44e82",
            mnd: "",
            acceptedToken: "0x8301f2213c0eed49a7e28ae4c3e91722919b8b47",
        },
        claimTokenPeriodStartAt: undefined,
        pool: { __typename: "Pool", title: "Seed round 1" },
        whitelists: [{ customerAddress: "" }],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: undefined,
        vestingTimes: undefined,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    purchase: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-03-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-03-04T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-03-08T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-03-10T11:00:00.000Z",
        swapTokenPeriodStartAt: "2022-03-10T03:00:00.000Z",
        swapTokenPeriodEndAt: "2022-03-23T10:30:00.000Z",
        // claimTokenPeriodStartAt: "2022-04-01T10:00:00.000Z",
        pool: { __typename: "Pool", title: "Community Pool" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: null,
        vestingTimes: null,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
    purchase_1: {
        __typename: "PoolEvent",
        _id: "621c6a6b22252f795c23c609",
        description: "Seed Round Pool",
        maxWinnerApplyWhitelist: 12,
        maxWinnerSwapToken: 6,
        maxAllocationAltCoin: 1200,
        competitionPeriodStartAt: "2022-02-02T08:00:00.000Z",
        competitionPeriodEndAt: "2022-02-04T08:00:00.000Z",
        whitelistPeriodStartAt: "2022-02-08T10:00:00.000Z",
        whitelistPeriodEndAt: "2022-02-09T11:00:00.000Z",
        swapTokenPeriodStartAt: "2022-03-08T03:00:00.000Z",
        swapTokenPeriodEndAt: "2022-03-10T08:30:00.000Z",
        // claimTokenPeriodStartAt: "2022-04-01T10:00:00.000Z",
        pool: { __typename: "Pool", title: "Community Pool" },
        whitelists: [],
        claimTokenPolicy: "5% at TGE + Lock 6 months, Linear vesting in 12 months",
        claimTGEPercent: null,
        vestingTimes: null,
        pricePerToken: "0.015",
        availableAmountToken: "40000000",
        contributeAmountToken: "10000",
        updatedAt: "2022-02-28T06:23:39.353Z",
    },
};
